import { DEFAULT_ROUTES } from "@/constants/routes";

const ROOT = DEFAULT_ROUTES.CONTRACT_MANAGEMENT;

/**
 * Paths of the Gestão Contratual module. URLs are user-facing, so they stay in
 * Portuguese; the keys are English like the rest of the code. Build concrete
 * paths with react-router's `generatePath`.
 */
export const CONTRACT_MANAGEMENT_ROUTES = {
  ROOT,
  COMMITMENTS: `${ROOT}/compromissos`,
  COMMITMENT_CREATE: `${ROOT}/compromissos/novo`,
  COMMITMENT_DETAIL: `${ROOT}/compromissos/:commitmentId`,
  CLIENTS: `${ROOT}/clientes`,
  COMPANY_CREATE: `${ROOT}/clientes/empresas/nova`,
  COMPANY_DETAIL: `${ROOT}/clientes/empresas/:companyId`,
  GROUP_CREATE: `${ROOT}/clientes/grupos/novo`,
  GROUP_DETAIL: `${ROOT}/clientes/grupos/:groupId`,
  ALLOCATIONS: `${ROOT}/alocacoes`,
  ALLOCATION_DETAIL: `${ROOT}/alocacoes/:allocationId`,
  CONTRIBUTIONS: `${ROOT}/aportes`,
  // The aporte id is not unique alone in the sample: the route carries the
  // commitment (spec-alocacoes-aportes, open point 2).
  CONTRIBUTION_DETAIL: `${ROOT}/aportes/:commitmentId/:contributionId`,
  EXTRA_CREDITS: `${ROOT}/aportes/:commitmentId/extras`,
  PARTNERS: `${ROOT}/parceiros`,
  PARTNER_DETAIL: `${ROOT}/parceiros/:partnerId`,
} as const;
